<template>
  <div>
    <Modal class="my-modal" v-model="visible" title="选择文章" :mask-closable="false" :footer-hide="true" width="1200px">
      <div class="search-box">
        <div class="input-item">
          <span class="label">文章标题</span>
          <Input v-model="searchParams.title" placeholder="请输入文章标题" clearable />
        </div>
        <div class="input-item">
          <span class="label">文章类型</span>
          <Select v-model="searchParams.type" transfer placeholder="请选择文章类型" clearable>
            <Option value="1">图文</Option>
            <Option value="2">视频</Option>
            <Option value="3">外链</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">文章分类</span>
          <selectTreeOld :data="columnList" :multiple="false" :size="null" placeholder="请选择" :single="true"
            :showParentNode="true" :selectAllChildren="false" v-model="searchParams.columnId" transfer></selectTreeOld>
        </div>
        <div class="input-item">
          <span class="label">关联产品</span>
          <Select :label-in-value="true" v-model="searchParams.productCodeList" placeholder="请选择" clearable multiple transfer>
            <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{
              product.productName }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">来源</span>
          <Select v-model="searchParams.source" transfer placeholder="请选择来源" clearable>
            <Option value="0">素材库</Option>
            <Option value="1">自建</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">展示机构</span>
          <selectTree type="4" status="1" v-model="searchParams.orgId"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">发布时间</span>
          <DatePicker type="daterange" split-panels separator="至" :transfer="true" placement="bottom" format="yyyy-MM-dd"
            placeholder="选择日期" :value="searchParams.date" @on-change="searchParams.date = $event"></DatePicker>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="getList()">查询</Button>
          <Button type="primary" ghost @click="resetSearch();searchParams.date=[]">重置</Button>
        </div>
      </div>
      <div class="tableBox">
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="title">
            <span class="articleUrl" @click="clickArticle(row)">{{ row.title }}</span>
          </template>
          <template slot-scope="{ row }" slot="columnName">
            <div v-for="(item, i) in row.columnName" :key="i">
              <span>{{ item }}</span>
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <div>
              <span class="table-btn" @click="getArticle(row)">选择</span>
            </div>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
          style="text-align: center; margin-top: 20px" />
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool } from "@/api/mixins";
import selectTreeOld from '@/components/commons/selectTree';
import selectTree from '@/components/system/selectTree3';
export default {
  mixins: [pageTool],
  components: {
    selectTreeOld,
    selectTree,
  },
  data() {
    return {
      visible: false,
      total: 0,
      pageNo: 1,
      pageSize: 10,
      searchParams: {
        columnId: []
      },
      productListArr: [],
      columnList: [],
      timeArray: [],
      columns: [
        {
          title: "文章标题",
          align: "center",
          slot: "title",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "文章类型",
          align: "center",
          key: "type",
          minWidth: 100,
          tooltip: true,
          render(h, params) {
            if (params.row.type == 1) {
              return <span>图文</span>
            } else if (params.row.type == 2) {
              return <span>视频</span>
            } else {
              return <span>外链</span>
            }
          }
        },
        {
          title: "文章分类",
          align: "center",
          slot: "columnName",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "来源",
          align: "center",
          key: "sourceName",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "最后更新人",
          align: "center",
          key: "updateByName",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "发布时间",
          align: "center",
          key: "useTime",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          align: 'center',
          width: 180,
          fixed: 'right'
        }
      ],
      tableData: []
    }
  },
  methods: {
    setListParams(params) {
      params.isUse = 1
      if (this.searchParams.date && this.searchParams.date.length > 0) {
        params.beginPublishTime = this.searchParams.date[0]
        params.endPublishTime = this.searchParams.date[1]
      }
      params.columnId = params.columnId.length > 0 ? params.columnId[0] : ''
    },
    clickArticle(row) {
      window.open(row.url, "_blank")
    },
    getArticle(row) {
      this.$emit('changeArticle', row)
      this.visible = false
    },
    open() {
      this.visible = true
      this.getProductList()
      this.getColumnList()
      this.initListAjax("/buz/cmsArticle/read/list");
    },
    getTreeData(treeData) {
      this.treeData = treeData;
      this.$nextTick(() => {
        this.deepCheck(treeData);
        this.$refs.selectTreeRef.setSelectIdByChecked();
      });
    },
    deepCheck(treeData) {
      treeData.forEach(item => {
        item.checked = true;
        if (item.children.length) {
          this.deepCheck(item.children)
        }
      })
    },
    // 权限勾选
    treeClick(data) {
      if (data.checked) {
        if (this.treeData[0].id != data.id) {//当前节点不是顶级的直接子级
          this.findTreeParent(this.treeData, data.parentId);
        }
        this.findTreeList([data], true);//勾选子级
      } else {
        this.findTreeList([data], false);//去掉子级勾选
      }
      this.$refs.selectTreeRef.setSelectIdByChecked();
    },
    findTreeParent(tree, id) {
      tree.find(item => {
        if (item.id == id) {
          this.$set(item, 'checked', true)
          if (!item.isTop) {//存在非顶级继续查找
            return this.findTreeParent(this.treeData, item.parentId);
          } else {
            return true;
          }
        }
        if (item.children && item.children.length) {
          return this.findTreeParent(item.children, id)
        }
        return false;
      })
    },
    findTreeList(tree, checked) {
      tree.forEach(item => {
        this.$set(item, 'checked', checked)
        if (item.children && item.children.length) {
          this.findTreeList(item.children, checked)
        }
      })
    },
    getColumnList() {
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: "POST",
        data: {
          type: 1,
        }
      }).then(res => {
        this.columnList = this.dealTree(res.data);
      })
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },
    // 产品
    getProductList() {
      this.$http({
        url: "/buz/productBase/read/short/list",
        type: "post",
        data: {
          pageNo: 1,
          pageSize: 9999,
        },
      }).then((res) => {
        this.productListArr = res.data;
      }).catch((err) => {
        console.log(err)
      });
    },
  }

}
</script>

<style lang="scss" scoped>
.articleUrl {
  color: #236dff;

  &:hover {
    cursor: pointer;
  }
}
/deep/ .input-item{
  width: 33.33% !important;
}
</style>